import { Text } from '@/ui-kit'

type FieldLabelProps = {
  label: string
  description?: string
  required: boolean
  hint?: string
}

export const FieldLabel = ({ label, description, required, hint }: FieldLabelProps) => (
  <div className="flex flex-col gap-1">
    <Text type="body1-semibold" className="text-gray-70">
      {label}
      {required && <span className="text-red ml-1">*</span>}
    </Text>
    {description && (
      <Text type="body3-regular" className="text-gray-90">
        {description}
      </Text>
    )}
    {hint && (
      <Text type="body3-regular" className="text-gray-90">
        {hint}
      </Text>
    )}
  </div>
)
